import { get } from '~/services/http-requests'

const _BS_PAYMENT = 'payment'

export async function fetchClientToken(): Promise<string> {
    const data = await get({ fullUrl: `${_BS_PAYMENT}/get_client_token/`, isFreeRequest: true })
    return data.client_token
}
